




























import Vue from 'vue';
import mixin from 'vue-typed-mixins';
import { toastMixin } from '@/Shared/CommonEntityMixins/ToastMixin';
import ValidationErrorDirective, { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { Dictionary } from 'vue-router/types/router';
import { Location } from '@/Stores/UserStore';
import VatsAPI from '@/Shared/VatsAPI';
import I18nMixin from '@/Shared/I18nMixin';

const PasswordResetRequest = mixin(toastMixin, I18nMixin).extend({
    data() {
        return {
            userId: '',
            validationErrors: {} as Dictionary<string[]>,
            errorMessage: null as string | null,
        };
    },
    directives: {
        ValidationErrorDirective
    },
    computed: {
        i18nPrefix() {
            return 'passwordResetRequest';
        }
    },
    methods: {
        async submit() {
            this.validationErrors = {};
            this.errorMessage = null;
            try {
                await VatsAPI.get(`/Account/RequestPasswordReset`, { params: { userID: this.userId }});

                this.popupToast('requestSuccessTitle', 'requestSuccessMessage', this.i18nPrefix);
                this.userId = '';
            }
            catch (e) {
                if (!e.response || e.response.status !== 400 || !e.response.data) {
                    this.popupToast('requestFailedTitle', 'requestFailedMessage', this.i18nPrefix);
                    return;
                }

                this.validationErrors = getValidationErrors(e.response);
            }
        },
    },
});

export default PasswordResetRequest;
